import React, { Component, useEffect, useState } from "react";
import Pagination from "../Std/Pagination";
import * as utilities from "../../utilities/utils";
import history from "../../utilities/history";
import Backbutton from "../../containers/Common/Backbutton";
import CaseStatus from "../../containers/CaseStatus";
import SearchComponent from '../SearchComponent';

const initialState = {
  searchKeyword: {
    value: "",
    error: "",
    validation: {
      required: true,
    },
  },
  isGridView: true,
};
const AirApplicantComponent = (props, context) => {
  const [state, setstate] = useState(initialState);

  // Set state to initial state on change component
  useEffect(() => {
    return () => {
      setstate((state) => {
        return {
          ...initialState,
        };
      });
    };
  }, []);

  const handleChanges = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = { ...state[name] };
    updatedObj.value = type === "checkbox" ? checked : value.trimLeft();

    setstate((state) => {
      return {
        ...state,
        [name]: updatedObj,
      };
    });
  };

  const onClickAttachment = (ein) => {
    history.push(`/attachments?ein=${ein}`);
  };

  const onViewChange = (view) => {
    setstate((state) => {
      return {
        ...state,
        isGridView: view,
      };
    });
  };

  // const onDropDownChange = (event) => {
  //   let { name, value } = event;

  //   if (value.length) {
  //     props.onPageSizeChange(utilities.extractFirstValueOfArray(value));
  //   }
  // };

  const onSearch = () => {
    if (state.searchKeyword.value.trim()) {
      props.searchByName(state.searchKeyword.value.trim());
    } else {
      props.searchByName(null);
    }
  };

  const onChange = (event) => {
    props.onChange({
      name: event.target.name,
      value: event.target.value,
      searchKey: state.searchKeyword.value.trim()
        ? state.searchKeyword.value.trim()
        : null,
    });
  };

  // const openDetailModal = (employeeEIN) => {
  //   props.openSetModal(
  //     <ErsCaseStatusDetailModal employeeEIN={employeeEIN} {...props} />
  //   );
  // };

  return (
    <>
      <div className="Dashboard-Content">
        <div className="row">
          <div className="back-btn-outer">
            <Backbutton />

            <div className="applicant-view-tab">
              <ul className="nav nav-pills">
                <li className="nav-item table-btn">
                  <a
                    // onClick={() => onViewChange(false)}
                    className={
                      !state.isGridView
                        ? "nav-link active table-btn"
                        : "nav-link table-btn"
                    }
                  >
                    Table
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    onClick={() => onViewChange(true)}
                    className={
                      state.isGridView
                        ? "nav-link grid-btn active"
                        : "nav-link grid-btn"
                    }
                  >
                    Grid
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {state.isGridView ? (
          <>
            <div className="Inner-cell">
            <div class="row">
              <SearchComponent  searchKeyword={state.searchKeyword} handleChanges={handleChanges} context={props.context} onSearch={onSearch}/>
            </div>
            </div>

            <div className="row">
              <span className="search-text">All Applicants</span>
              {Array.isArray(props.applicants) && props.applicants.length
                ? props.applicants.map((applicant) => (
                    <div
                      // key={`${applicant.employeeId}-${applicant.fullName}`}
                      className="col-12 col-sm-12 col-md-12 col-lg-4"
                    >
                      <div className="s-box">
                        <div className="srv-img">
                          <div className="display-name">
                            {applicant.fullName
                              ? utilities.convertIntoIconName(
                                  applicant.fullName
                                )
                              : "-"}
                          </div>
                          <h2>
                            {applicant.fullName ? applicant.fullName : "-"}
                          </h2>
                          {/* <small className="display-ein">
                            {applicant.employeeId ? applicant.employeeId : null}
                          </small> */}
                          <div>
                            <div
                              className="r-more"
                              onClick={() =>
                                onClickAttachment(applicant.employeeId)
                              }
                            >
                              Documents
                            </div>
                          </div>
                          <div>
                            <div
                              // onClick={() =>
                              //   history.push(
                              //     `/allcasedetails?ein=${applicant.employeeId}`
                              //   )
                              // }
                              className="r-more"
                            >
                              Case Status
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : null}
            </div>
            <div>
              <span htmlFor="">{props.context.t("Attachment.TotalRows.Text")}: {props.totalRows}</span>

              <Pagination
                currentPage={props.currentPage}
                pageSize={props.pageSize}
                totalRows={props.totalRows}
                onClickPre={(pageNo) => {
                  onChange({
                    target: {
                      name: "currentPage",
                      value: pageNo,
                    },
                  });
                  utilities.scrollToTop();
                }}
                onClickNext={(pageNo) => {
                  onChange({
                    target: {
                      name: "currentPage",
                      value: pageNo,
                    },
                  });
                  utilities.scrollToTop();
                }}
                onClickPage={(pageNo) => {
                  onChange({
                    target: {
                      name: "currentPage",
                      value: pageNo,
                    },
                  });
                  utilities.scrollToTop();
                }}
              ></Pagination>
            </div>
          </>
        ) : (
          <CaseStatus />
        )}
      </div>
    </>
  );
};

export default AirApplicantComponent;
